import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { manageCubesQueryKeys } from "./queryKeys";

const POLL_INTERVAL_MS = 3_000;
const MAX_POLL_COUNT = 100; // ~5 minutes at 3s intervals

export function usePollExport(
  uid: string | undefined,
  sfqid: string | undefined,
  enabled: boolean
) {
  const apiClient = useApi();
  const pollCountRef = useRef(0);

  useEffect(() => {
    pollCountRef.current = 0;
  }, [uid]);

  return useQuery({
    queryKey: manageCubesQueryKeys.exportPoll(uid ?? ""),
    meta: {
      errorMessage: "Failed to poll export status"
    },
    queryFn: async () => {
      pollCountRef.current += 1;
      const response = await apiClient.POST("/v2/forecast/exports/poll", {
        body: { uid: uid!, sfqid: sfqid! }
      });

      return response.data?.result;
    },
    enabled: enabled && !!uid && !!sfqid,
    refetchInterval: (query) => {
      const isReady = query.state.data?.status === "ready";
      const exceeded = pollCountRef.current >= MAX_POLL_COUNT;
      if (isReady || exceeded) return false;
      return POLL_INTERVAL_MS;
    }
  });
}
